import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./ViewDoc.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchViewDocumentHistory } from "../../../../Redux/Slices/bankingSlice";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import Loader from "../../../../commons/Loader/Loader";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";

const ViewDoc = ({
  open,
  handleClose,
  connectionId,
  viewDocData,
  activeCounterparty,
}) => {
  const selfListingData = viewDocData?.[0]?.selfListing?.companyName;

  const dispatch = useDispatch();
  const { documentViewHistory, loading, error } = useSelector(
    (state) => state.bankingSlice
  );

  useEffect(() => {
    if (connectionId) {
      dispatch(fetchViewDocumentHistory(connectionId));
    }
  }, [dispatch, connectionId]);

  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) {
        setPreviewFileUrl(url);
        setSelectedDocumentId(id);
        setPreviewModal(true);
      } else {
        alert("Document URL not found");
      }
    } catch (err) {
      alert("Could not fetch document URL.");
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
    setSelectedDocumentId(null);
  };
  const formatDocType = (type) => {
    if (!type) return "";
    if (type.toUpperCase() === "RANDOM") return "Others";
    return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">View Document</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.docContainer}>
            {/* Header Row */}
            <div className={`${Styles.docHeaderRow} ${Styles.docRow1}`}>
              <div className={`${Styles.docCol} ${Styles.companyName}`}>
                Company Name
              </div>

              <div className={`${Styles.docCol} ${Styles.type}`}>Type</div>

              <div className={`${Styles.docCol} ${Styles.createdAt}`}>
                Uploaded At
              </div>
              <div className={`${Styles.docCol} ${Styles.filename}`}>
                File Name
              </div>
              <div className={`${Styles.docCol} ${Styles.view}`}>View</div>
            </div>

            <div className={Styles.docContentScroll}>
              {loading ? (
                <div className={Styles.loadingRow}>
                  <Loader />
                </div>
              ) : error ? (
                <p className={Styles.error}>{error}</p>
              ) : documentViewHistory?.length > 0 ? (
                documentViewHistory.map((doc) => (
                  <div className={Styles.docRow} key={doc.id}>
                    <div
                      className={`${Styles.docCol} ${Styles.companyName} ${Styles.docContent}`}
                    >
                      {doc.companyName}
                      {/* {doc.listingId} */}
                    </div>

                    {/* New Document Type Column */}
                    <div
                      className={`${Styles.docCol} ${Styles.type} ${Styles.docContent}`}
                      style={{ textTransform: "uppercase" }}
                    >
                      {formatDocType(doc.documentType)}
                    </div>

                    <div
                      className={`${Styles.docCol} ${Styles.createdAt} ${Styles.docContent}`}
                    >
                      {new Date(doc.createdAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </div>
                    <div
                      className={`${Styles.docCol} ${Styles.filename} ${Styles.docContent}`}
                    >
                      {doc.filename}
                    </div>
                    <div
                      className={`${Styles.docCol} ${Styles.view} ${Styles.docContent}`}
                    >
                      <span
                        onClick={() => handleViewDoc(doc.id)}
                        className={Styles.viewLink}
                        style={{ cursor: "pointer" }}
                      >
                        <ViewIcon />
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <p>No document history found.</p>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <PreviewModal
        open={previewModal}
        onClose={handleClosePreview}
        fileUrl={previewFileUrl}
        disableDownload={true}
        documentId={selectedDocumentId}
      />
    </>
  );
};

export default ViewDoc;
